<div class="img_wrap task-trigger" [matMenuTriggerFor]="taskMenu" #taskMenuTrigger="matMenuTrigger"
  (menuOpened)="onMenuOpen()">
  <img src="../../../../assets/img/tasks_icons.svg" alt="" class="icon" />
  <!-- <span class="task-counter" *ngIf="pendingTaskCount > 0">{{ pendingTaskCount }}</span> -->
</div>

<mat-menu #taskMenu="matMenu" class="task-menu">

  <!-- Professional Header Section - Matching Vendor Quotes Style -->
  <div class="task-header" (click)="$event.stopPropagation()">
    <div class="header-content">
      <div class="header-title-section">
        <mat-icon class="header-icon">task_alt</mat-icon>
        <span class="task-title">Tasks</span>
      </div>

      <!-- Right Controls Group -->
      <div class="header-controls-group">
        <!-- Density Toggle -->
        <div class="density-toggle">
          <button class="density-btn" [class.active]="viewMode === 'comfortable'"
            (click)="setViewMode('comfortable')" matTooltip="Comfortable View" matTooltipPosition="below">
            <mat-icon>view_agenda</mat-icon>
          </button>
          <button class="density-btn" [class.active]="viewMode === 'compact'" (click)="setViewMode('compact')"
            matTooltip="Extra Compact View" matTooltipPosition="below">
            <mat-icon>view_stream</mat-icon>
          </button>
        </div>

        <!-- Task Filter Dropdown (static UI only) -->
        <div class="task-filter-dropdown">
          <button class="filter-trigger-btn" [matMenuTriggerFor]="filterMenu"
            #filterMenuTrigger="matMenuTrigger" matTooltip="Filter Tasks" matTooltipPosition="below">
            <mat-icon>filter_list</mat-icon>
            <span class="filter-label">{{ getFilterLabel() }}</span>
            <mat-icon class="dropdown-icon">arrow_drop_down</mat-icon>
          </button>

          <mat-menu #filterMenu="matMenu" class="task-filter-menu" [hasBackdrop]="false">
            <button type="button" class="mat-menu-item" [class.active]="taskFilter === 'non-completed'" (click)="$event.stopPropagation()">
              <input type="radio" class="filter-radio" name="taskFilterMenu"
                [checked]="taskFilter === 'non-completed'"
                (change)="setTaskFilter('non-completed'); onFilterMenuItemClick($event)" />
              <span>Active Tasks</span>
              <span class="count-badge">{{ taskCount?.active_task_count }}</span>
            </button>
            <button type="button" class="mat-menu-item" [class.active]="taskFilter === 'completed'" (click)="$event.stopPropagation()">
              <input type="radio" class="filter-radio" name="taskFilterMenu"
                [checked]="taskFilter === 'completed'"
                (change)="setTaskFilter('completed'); onFilterMenuItemClick($event)" />
              <span>Completed Tasks</span>
              <span class="count-badge">{{ taskCount?.completed_task_count }}</span>
            </button>
            <button type="button" class="mat-menu-item" [class.active]="taskFilter === 'all'" (click)="$event.stopPropagation()">
              <input type="radio" class="filter-radio" name="taskFilterMenu"
                [checked]="taskFilter === 'all'"
                (change)="setTaskFilter('all'); onFilterMenuItemClick($event)" />
              <span>All Tasks</span>
              <span class="count-badge">{{ taskCount?.all_task_count }}</span>
            </button>
          </mat-menu>
        </div>
      </div>
    </div>
  </div>

  <!-- Enhanced Controls Section -->
  <div class="task-controls" (click)="$event.stopPropagation()">
    <!-- Search Section -->
    <div class="search-section">
      <mat-icon>search</mat-icon>
      <input type="search" [(ngModel)]="search" [ngModelOptions]="{ standalone: true }"
        (keyup.enter)="onSearchTextChange()" (ngModelChange)="onSearch()" placeholder="Search tasks..."
        class="search-input">
    </div>
  </div>

  <!-- Task List Container -->
  <div class="task-content" (click)="$event.stopPropagation()">
    <div class="task-list-container">
      @if (!isReloading) {
        <div class="task-list">
          <!-- Loop through tasks (no filtering) -->
          @for (task of tasksList; track task) {
            <!-- Enhanced Task Card - Three-Tier Layout (Comfortable View) -->
            @if (viewMode === 'comfortable') {
              <div class="task-card-enhanced"
                [style.border-left-color]="task.status_label?.color || '#ff6600'">
                <!-- Tier 1: Task Name + Status + Due Date + Priority (Primary Scan Line) -->
                <div class="card-tier-1">
                  <div class="task-identifier">
                    <mat-icon class="task-type-icon">assignment</mat-icon>
                    <h4 class="task-name" [matTooltip]="formatTaskName(task.name)"
                      matTooltipPosition="above">
                      {{ formatTaskName(task.name) }}
                    </h4>
                  </div>
                  <div class="status-and-due" (click)="$event.stopPropagation()">
                    <!-- Task Status Badge -->
                    @if (task.status_label) {
                      <span class="status-badge"
                        [style.background-color]="task.status_label?.color"
                        [matTooltip]="'Status: ' + task.status_label?.name" matTooltipPosition="above">
                        {{ task.status_label?.name || 'N/A' }}
                      </span>
                    }
                    <!-- Due Date Countdown Badge -->
                    @if (getDueDateBadge(task)) {
                      <span class="due-badge"
                        [class.overdue]="isDueOverdue(task)" [class.urgent]="isDueUrgent(task)"
                        [matTooltip]="task.due_date_formatted || task.due_date" matTooltipPosition="above">
                        {{ getDueDateBadge(task) }}
                      </span>
                    }
                    <!-- Priority Badge -->
                    <span class="priority-badge" [matMenuTriggerFor]="statusMenu"
                      [ngStyle]="{'background-color': getPriorityDetail(task?.priority)?.color ?? 'red'}"
                      [matTooltip]="'Priority: ' + (getPriorityDetail(task?.priority)?.name ?? '--')"
                      matTooltipPosition="above">
                      {{getPriorityDetail(task?.priority)?.name ?? '--'}}
                    </span>
                    <!-- Action Menu Button -->
                    <button class="action-menu-btn"
                      [ngClass]="{'disabled-icon': task?.request_takeoff?.status == 3 || task?.request_takeoff == null }"
                      (click)="$event.stopPropagation(); setCurrentTask(task)"
                      [matMenuTriggerFor]="takeoffMenu" #childMenuTrigger="matMenuTrigger">
                      <mat-icon>more_vert</mat-icon>
                    </button>
                  </div>
                </div>
                <mat-menu #statusMenu="matMenu" class="status-menu-enhanced">
                  @for (priorityItem of priority; track priorityItem) {
                    <button (click)="onChangeStatus(task?.id, priorityItem); $event.stopPropagation()"
                      mat-menu-item class="priority-menu-item">
                      <span class="priority-indicator"
                      [ngStyle]="{'background-color': priorityItem.color }"></span>
                      <span>{{priorityItem.name}}</span>
                    </button>
                  }
                </mat-menu>
                <!-- Tier 2: Description Preview Only -->
                @if (task.description) {
                  <div class="card-tier-2-description">
                    <mat-icon class="desc-icon">notes</mat-icon>
                    <span>{{ getDescriptionPreview(task.description) }}</span>
                  </div>
                }
                <!-- Tier 3: Progress + Timeline + Metadata + Assignees -->
                <div class="card-tier-3-expanded">
                  <!-- Progress Bar Section -->
                  @if (hasChecklist(task)) {
                    <div class="progress-section">
                      <div class="progress-bar-container">
                        <div class="progress-bar-fill" [style.width.%]="task.checklist_progress"
                          [style.background-color]="getProgressColor(task.checklist_progress)">
                        </div>
                      </div>
                      <span class="progress-text">{{ task.checklist_progress }}%</span>
                      <span class="checklist-count">({{ task.checklist_completed }}/{{ task.checklist_total
                      }})</span>
                    </div>
                  }
                  <!-- Timeline Info: Creator & Due Date -->
                  @if (task.created_by || task.due_date_formatted) {
                    <div class="timeline-info">
                      <!-- Created By -->
                      @if (task.created_by) {
                        <span class="created-by">
                          <mat-icon class="info-icon">person_outline</mat-icon>
                          <span>{{ task.created_by.full_name }}</span>
                        </span>
                      }
                      <!-- Due Date -->
                      @if (task.due_date_formatted) {
                        <span class="due-date">
                          <mat-icon class="info-icon">event</mat-icon>
                          <span>{{ task.due_date_formatted }}</span>
                        </span>
                      }
                    </div>
                  }
                  <!-- Metadata Items + Assignees -->
                  <div class="metadata-and-assignees">
                    <div class="metadata-items">
                      <!-- Mark as Complete Button -->
                      <button class="metadata-item complete-btn" [class.completed]="isTaskCompleted(task)"
                        [class.inprogress]="!isTaskCompleted(task)"
                        [disabled]="isTaskCompleted(task)"
                        [attr.aria-disabled]="isTaskCompleted(task)"
                        [matTooltip]="isTaskCompleted(task) ? 'Completed' : 'Mark as complete'"
                        matTooltipPosition="above"
                        (click)="!isTaskCompleted(task) && markAsComplete(task, $event)">
                        <mat-icon>{{ isTaskCompleted(task) ? 'check_circle' : 'check_circle' }}</mat-icon>
                      </button>
                      <!-- Comments -->
                      <div class="metadata-item comments-meta" matTooltip="Task Comments"
                        matTooltipPosition="above">
                        <mat-icon>speaker_notes</mat-icon>
                        <span>{{ task.comments?.length || 0 }}</span>
                      </div>
                      <!-- Attachments -->
                      <div class="metadata-item attachments-meta" matTooltip="Attachments"
                        matTooltipPosition="above">
                        <mat-icon>attach_file</mat-icon>
                        <span>{{ task.relations?.attach_files?.length || 0 }}</span>
                      </div>
                      <!-- Info button -->
                      <button class="metadata-item info-btn" matTooltip="View Task Details"
                        matTooltipPosition="above" (click)="openTaskDetail(task)">
                        <mat-icon>info</mat-icon>
                      </button>
                    </div>
                    <!-- Assignees -->
                    @if (task?.responsible_persons?.length > 0) {
                      <div class="assignees-section">
                        <app-avatar-group [maxDisplay]="3" [widthSize]="'32px'" [heightSize]="'32px'"
                          [avatars]="mapUsers(task?.responsible_persons)" [showStatusIndicator]="true">
                        </app-avatar-group>
                      </div>
                    }
                  </div>
                </div>
              </div>
            }
            <!-- Extra Compact Task Card - Single Line (Compact View) -->
            @if (viewMode === 'compact') {
              <div class="task-card-compact"
                [style.border-left-color]="task.status_label?.color || '#ff6600'">
                <!-- Single Line Layout -->
                <div class="compact-line">
                  <!-- Task Icon + Name -->
                  <div class="compact-task-name">
                    <mat-icon class="compact-icon">assignment</mat-icon>
                    <span [matTooltip]="formatTaskName(task.name)" matTooltipPosition="above">{{
                    formatTaskName(task.name) }}</span>
                  </div>
                  <!-- Status Initial Badge -->
                  @if (task.status_label) {
                    <span class="compact-status-badge"
                      [style.background-color]="task.status_label?.color"
                      [matTooltip]="'Status: ' + task.status_label?.name" matTooltipPosition="above">
                      {{ getStatusInitial(task.status_label?.name) }}
                    </span>
                  }
                  <!-- Priority Initial Badge -->
                  <span class="compact-priority-badge" [matMenuTriggerFor]="compactStatusMenu"
                    [ngStyle]="{'background-color': getPriorityDetail(task?.priority)?.color ?? 'red'}"
                    [matTooltip]="'Priority: ' + (getPriorityDetail(task?.priority)?.name ?? '--')"
                    matTooltipPosition="above">
                    {{ getPriorityInitial(task?.priority) }}
                  </span>
                  <!-- Due Date Badge (Compact) -->
                  @if (getDueDateBadge(task)) {
                    <span class="compact-due-badge"
                      [class.overdue]="isDueOverdue(task)" [class.urgent]="isDueUrgent(task)"
                      [matTooltip]="task.due_date_formatted || task.due_date" matTooltipPosition="above">
                      {{ getDueDateBadge(task) }}
                    </span>
                  }
                  <!-- Mini Progress Bar -->
                  @if (hasChecklist(task)) {
                    <div class="compact-progress">
                      <div class="compact-progress-bar" [style.width.%]="task.checklist_progress"
                        [style.background-color]="getProgressColor(task.checklist_progress)">
                      </div>
                    </div>
                  }
                  <!-- Metadata Counts -->
                  <div class="compact-metadata">
                    @if (task.comments?.length > 0) {
                      <span class="compact-meta-item"
                        [matTooltip]="task.comments?.length + ' comments'" matTooltipPosition="above">
                        <mat-icon>speaker_notes</mat-icon>{{ task.comments?.length }}
                      </span>
                    }
                    @if (task.relations?.attach_files?.length > 0) {
                      <span class="compact-meta-item"
                        [matTooltip]="task.relations?.attach_files?.length + ' attachments'"
                        matTooltipPosition="above">
                        <mat-icon>attach_file</mat-icon>{{ task.relations?.attach_files?.length }}
                      </span>
                    }
                  </div>
                  <!-- Mini Avatar Group -->
                  @if (task?.responsible_persons?.length > 0) {
                    <div class="compact-avatars">
                      <app-avatar-group [maxDisplay]="3" [widthSize]="'32px'" [heightSize]="'32px'"
                        [avatars]="mapUsers(task?.responsible_persons)" [showStatusIndicator]="true">
                      </app-avatar-group>
                    </div>
                  }
                  <!-- Mark as Complete Button (Compact) -->
                  <button class="compact-complete-btn" [class.completed]="isTaskCompleted(task)"
                    [class.inprogress]="!isTaskCompleted(task)" [disabled]="isTaskCompleted(task)"
                    [attr.aria-disabled]="isTaskCompleted(task)"
                    [matTooltip]="isTaskCompleted(task) ? 'Completed' : 'Mark as complete'"
                    matTooltipPosition="above"
                    (click)="!isTaskCompleted(task) && (markAsComplete(task, $event)); $event.stopPropagation()">
                    <mat-icon>{{ isTaskCompleted(task) ? 'check_circle' : 'check_circle' }}</mat-icon>
                  </button>
                  <!-- Info Button -->
                  <button class="compact-info-btn" matTooltip="View Task Details" matTooltipPosition="above"
                    (click)="openTaskDetail(task); $event.stopPropagation()">
                    <mat-icon>info</mat-icon>
                  </button>
                  <!-- Action Menu Button -->
                  <button class="compact-action-btn"
                    [ngClass]="{'disabled-icon': task?.request_takeoff?.status == 3 || task?.request_takeoff == null }"
                    (click)="$event.stopPropagation(); setCurrentTask(task)"
                    [matMenuTriggerFor]="takeoffMenu" #childMenuTrigger="matMenuTrigger">
                    <mat-icon>more_vert</mat-icon>
                  </button>
                </div>
                <!-- Compact Priority Menu -->
                <mat-menu #compactStatusMenu="matMenu" class="status-menu-enhanced">
                  @for (priorityItem of priority; track priorityItem) {
                    <button (click)="onChangeStatus(task?.id, priorityItem); $event.stopPropagation()"
                      mat-menu-item class="priority-menu-item">
                      <span class="priority-indicator"
                      [ngStyle]="{'background-color': priorityItem.color }"></span>
                      <span>{{priorityItem.name}}</span>
                    </button>
                  }
                </mat-menu>
              </div>
            }
          }
          <!-- Load More Button -->
          @if (!isLoading && showLoadMoreOption) {
            <div class="load-more-wrapper"
              (click)="$event.stopPropagation()">
              <button class="load-more-btn" (click)="loadMoreData($event)">
                <mat-icon>expand_more</mat-icon>
                <span>Load More Tasks</span>
              </button>
            </div>
          }
        </div>
      }

      <!-- Loading State -->
      @if (isLoading) {
        <div class="loading-state">
          <div class="spinner-border text-dark" role="status">
            <span class="sr-only">Loading...</span>
          </div>
          <span>Loading tasks...</span>
        </div>
      }

      <!-- Empty State -->
      @if (!isLoading && tasksList.length === 0) {
        <div class="empty-state">
          <mat-icon>task_alt</mat-icon>
          <h4>No Tasks Found</h4>
          <p>{{ search ? 'Try adjusting your search criteria' : 'No tasks have been assigned yet' }}</p>
        </div>
      }
    </div>
  </div>
</mat-menu>

<!-- Takeoff Menu -->
<mat-menu #takeoffMenu="matMenu" class="takeoff-menu" [hasBackdrop]="false">
  <button mat-menu-item (click)="onTakeoffMenuClick($event, currentTask)">
    {{currentTask?.request_takeoff?.status === 1 ? 'Mark takeoff request as in progress' : 'Mark takeoff request as
    completed'}}
  </button>
</mat-menu>